import commonHelpers from './common-helpers.es6'
import { objectEquals } from 'object-equals'

const itemHelpers = {
  mixins: [commonHelpers],
  data: function () {
    return {
      model: {
        name: '',
        tree: false
      },
      auxModels: [], // any auxilliary models
      id: this.$route.params.id,
      dataLoaded: false,
      editedItem: {},
      isUnsaved: false
    }
  },
  created () {
    this.storeUpdate()
  },
  computed: {
    isNew () {
      return !this.item.id
    },

    item: {
      get: function () {
        return this.$store.state.item[this.model.name]
      },
      set: function (newValue) {
        this.$store.state.item[this.model.name] = newValue
      }

    },
    items () {
      // Used by tree models
      return this.$store.state.items[this.model.name]
    },
    itemErrors () {
      return this.$store.state.itemErrors[this.model.name]
    }
  },
  methods: {
    // Others
    // ---
    // Computations
    // ---
    // Loaders
    storeUpdate () {
      console.log('[item-helpers][storeUpdate]')
      let promises = []
      // item
      if (this.$route.params.item) {
        // Deprecated (was used for virtual issues)
        // $route.params.ítem (if set, the data is taken from it)
        // console.log('[item][storeUpdate]: Item taken from params')
        // this.$store.commit('setItem', {modelName: this.model.name, item: this.$route.params.item})
        console.log('[item-helpers][DEPRECATED]')
      } else {
        // otherwise the data is taken from the BE
        promises.push(this.$store.dispatch('getItem',
          { modelName: this.model.name, id: this.id, newItem: this.$route.params.newItem }))
      }
      // items (for tree model)
      if (this.model.tree) {
        promises.push(this.$store.dispatch('getItems', { model: this.model }))
      }
      // auxes
      for (let auxModel of this.auxModels) {
        promises.push(this.$store.dispatch('getItems', { model: auxModel }))
      }
      return Promise.all(promises)
        .then(() => {
          this.beforeDataLoaded() // Data loaded, dataLoaded still false
          // this.editedItem = Object.assign({}, this.item) // Only for flat part of the object for now
          this.editedItem = JSON.parse(JSON.stringify(this.item)) // make deep copy
          this.dataLoaded = true
          this.afterDataLoaded() // Data loaded, dataLoaded already true
          return null
        }, (error) => {
          // Temporary solution for catching async-await errors
          // To be replaced with try-catch structure (when all Promises here are refactored)
          console.error(error)
        })
    },
    storeUpdateOnlyCoreModel () {
      let promises = []
      promises.push(this.$store.dispatch('getItem', { modelName: this.model.name, id: this.id, newItem: this.$route.params.newItem }))
      if (this.model.tree) {
        promises.push(this.$store.dispatch('getItems', { model: this.model }))
      }
      return Promise.all(promises)
        .then(() => {
          this.beforeDataLoaded()
          this.editedItem = Object.assign({}, this.item)
          this.dataLoaded = true
          this.afterDataLoaded()
        }, (error) => {
          console.error(error)
        })
    },
    beforeDataLoaded () {
      // To be inherited
    },
    afterDataLoaded () {
      if (!isNaN(parseInt(this.id)) && (!this.item.id || this.item.archivedAt)) {
        this.$router.replace({ name: 'entity-not-found', params: { entity: this.model.name, id: this.id } })
      }
    },
    // FE Actions
    normalizeEditedItem () {
      if (!this.item) {
        // item should always be defined when using this mixin!
        console.warn('[item-heplers][normalize] this.item is missing')
        return this.editedItem
      }

      Object.keys(this.item).map((key) => {
        if (this.editedItem[key] === undefined) {
          this.$set(this.editedItem, key, null)
        }
      })
      return this.editedItem
    },
    async handleSaveClick ({ refresh = false }) {
      if (refresh) {
        // refresh screen after new item is created
        const response = await this.save({ reRoute: false, snackbar: true, saveEditedItem: true })
        if (this.editedItem.id === undefined) {
          this.$router.replace({
            name: `${this.model.name}/id`,
            params: { id: response.data.id }
          })
        } else {
          this.$set(this, 'isUnsaved', false)
        }
      } else {
        // standard behaviour
        this.save({ reRoute: true, snackbar: true, saveEditedItem: true })
      }
    },
    // Actions
    async save ({ reRoute = true, snackbar = true, saveEditedItem = false }) {
      try {
        const item = saveEditedItem ? this.normalizeEditedItem() : this.item
        const data = await this.$store.dispatch('updateItem', { modelName: this.model.name, item })
        if (reRoute) {
          this.reRoute({ afterDestroy: false })
        }
        // Snackbar after succesful save (must come after re-routing)
        if (snackbar) {
          this.$store.commit('setFlat', { param: 'savedSnackbar', val: true })
        }
        return Promise.resolve(data)
      } catch (error) {
        console.error(error)
        return Promise.reject(error.message)
      }
    },
    // Routings
    reRoute () {
      // Re-routes after an action is performed
      // By default to own index route
      const reRouteDestination = { name: this.$router.currentRoute.path.split('/')[1] }
      if (reRouteDestination.name) {
        this.$router.push(reRouteDestination)
      }
    }
  },
  watch: {
    editedItem: {
      handler: function (next, prev) {
        if (Object.keys(prev).length > 0 && !this.isUnsaved && !objectEquals(next, this.item)) {
          this.$set(this, 'isUnsaved', true)
        }
      },
      deep: true
    }
  }
}

export default itemHelpers
